import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/leadFunctions/leadNoteActions'
import * as api from '../../api/lead/notes'

import { fetchLeadDetails } from '../leadDetails'

function* notesRefresh(action) {
  try {
    const payload = yield call(api.getLeadNotes, action.leadId)
    yield put({ type: constants.LEAD_NOTES_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_NOTES_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchNotes() {
  yield takeLatest(constants.LEAD_NOTES_REFRESH.ACTION, notesRefresh)
}

function* sagaCreateNote(action) {
  try {
    const payload = {
      lead_id: action.leadId,
      content: action.content
    }
    yield call(api.createNote, payload)
    yield put({ type: constants.LEAD_NOTE_CREATE.SUCCESS, payload })
    yield call(notesRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_NOTE_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateNote() {
  yield takeLatest(constants.LEAD_NOTE_CREATE.ACTION, sagaCreateNote)
}

function* sagaUpdateNote(action) {
  try {
    const payload = {
      lead_id: action.leadId,
      note_id: action.noteId,
      content: action.content,
      updated_by_id: action.userId
    }
    yield call(api.updateNote, payload)
    yield put({ type: constants.LEAD_NOTE_UPDATE.SUCCESS, payload })
    yield call(notesRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_NOTE_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateNote() {
  yield takeLatest(constants.LEAD_NOTE_UPDATE.ACTION, sagaUpdateNote)
}

function* sagaDeleteNote(action) {
  try {
    const payload = {
      note_id: action.noteId
    }
    yield call(api.deleteNote, payload)
    yield put({ type: constants.LEAD_NOTE_DELETE.SUCCESS, payload })
    yield call(notesRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_NOTE_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteNote() {
  yield takeLatest(constants.LEAD_NOTE_DELETE.ACTION, sagaDeleteNote)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([fork(watchNotes), fork(watchCreateNote), fork(watchUpdateNote), fork(watchDeleteNote)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/leadFunctions/leadNoteSaga.js